import removeInfoBarMessage from '../actions/removeInfoBarMessage';
import ComposeViewState from '../store/schema/ComposeViewState';
import setIRMData from '../actions/setIRMData';
import { InfoBarCustomAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import infoBarStrings from 'owa-strings/owa-common-strings';

export default function removeProtection(
    viewState: ComposeViewState,
    templateId: string
): InfoBarCustomAction {
    return {
        text: infoBarStrings.removeProtectionLink,
        action: () => {
            removeInfoBarMessage(viewState, templateId);
            setIRMData(viewState, null);
        },
    };
}
